let params = new URLSearchParams(window.location.search);

if (params.has("pv2") && params.has("variant")) {
  document.documentElement.style.display = "none";

  (async () => {
    try {
      let response = await fetch("https://shipping-app.altruan.de/google-discount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: window.location.href }),
      });

      let data = await response.json();

      if (data?.success && data?.shareable_url) {
        if (data.variant_id && data.google_price) {
          let key = `variant_${data.variant_id}`;
          let value = data.google_price;
          let expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `${key}=${value}; expires=${expires}; path=/; SameSite=Lax`;
        }

        let shareableUrl = new URL(data.shareable_url);
        if (!shareableUrl.searchParams.has("variant")) {
          shareableUrl.searchParams.set("variant", params.get("variant"));
        }

        if (!shareableUrl.searchParams.has("quantity") && data.quantity) {
          shareableUrl.searchParams.set("quantity", data.quantity);
        }

        window.location.replace(shareableUrl.toString());
      } else {
        params.delete("pv2");
        window.location.search = params.toString();
      }
    } catch (e) {
      params.delete("pv2");
      window.location.search = params.toString();
    }
  })();
}
